import { getLink } from "../../../utils/utils";

import translator from "./translator";

const content = {
  esp: (
    `
    <h4 class="mb-3 bold text-center">Kanto el poemo «Junona i Avosj»</h4>

    <p class="mb-3 bold text-center">* * *</p>

    <div class="poem">
      <p class="poem-block mb-3">
        Vi min dum mateniĝo vekigos, <br/>
        Vi senŝua al sojlo eliros, <br/>
        Kaj neniam plu vi min ekvidos, <br/>
        Kaj senĉese pri mi vi sopiros.
      </p>

      <p class="poem-block mb-3">
        Vin kaŝante de vento glacia <br/>
        Mi prokrastos, sen povo ekspiri: <br/>
        Mi sur ter’ vin revidos neniam, <br/>
        Kaj pri vi mi ne ĉesos sopiri.
      </p>

      <p class="poem-block mb-3">
        Du ĉerizoj enlarme dronitaj <br/>
        Min postsekvos en voj’ nigra mia. <br/>
        Sed reveni – malbona indico, <br/>
        Mi sur ter’ vin revidos neniam.
      </p>

      <p class="poem-block mb-3">
        En sonore malplena animo <br/>
        Nur du frazoj aŭdiĝos deliri: <br/>
        «Mi sur ter’ vin revidos neniam, <br/>
        Kaj pri vi mi ne ĉesos sopiri».
      </p>
    </div>
  `
  )
}

const itemName = {
  esp: 'Andrej Voznesenskij'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemVideo: ['2NKkPOlB-oo'],
    itemTranslator: translator.esp
  }
}

export default item;